import { type RefreshAllSitesResult, useRefreshAllSites } from "../api";
import { ProgressBar } from "./ProgressBar";
import styles from "./RefreshAdminData.module.css";

const names = (list: string[]): string => list.join(", ");

const Summary = ({ result }: { result: RefreshAllSitesResult }) => (
  <>
    <span>
      Refreshed {result.refreshed} of {result.total} site
      {result.total === 1 ? "" : "s"}.
    </span>
    {result.failed.length > 0 && (
      <span className={styles.problem}>
        Couldn&apos;t refresh: {names(result.failed)}.
      </span>
    )}
    {result.not_found.length > 0 && (
      <span className={styles.problem}>
        No longer on admin.inrange.io: {names(result.not_found)}.
      </span>
    )}
    {result.unreached.length > 0 && (
      <span className={styles.problem}>
        Ran out of time before: {names(result.unreached)}. Refresh again to
        finish them.
      </span>
    )}
  </>
);

export const RefreshAdminData = () => {
  const refresh = useRefreshAllSites();
  return (
    <div className={styles.wrap}>
      <button
        type="button"
        className={styles.button}
        onClick={() => void refresh.start()}
        disabled={refresh.running}
        title="Re-pulls all admin data for every linked project, including cost and survey"
      >
        {refresh.running ? "Refreshing…" : "Refresh admin data"}
      </button>
      {refresh.running && (
        <div className={styles.status}>
          <ProgressBar progress={refresh.progress} />
        </div>
      )}
      {!refresh.running && (refresh.result || refresh.error) && (
        <div className={styles.status} role="status">
          {refresh.result ? (
            <Summary result={refresh.result} />
          ) : (
            <span className={styles.problem}>
              Couldn&apos;t refresh admin data: {refresh.error}
            </span>
          )}
          <button
            type="button"
            className={styles.dismiss}
            onClick={refresh.dismiss}
          >
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
};
